/**
*
*   Confirm Modal
*       - The Confirm Modal
*
**/
'use client';

import Button from '@/components/button';
import Preloader from '@/components/preloader';
import { useState } from 'react';
import { useTranslations } from 'next-intl';


//Build the Element
export default function ConfirmModal({ Modal }){

	//Translations
	const t = useTranslations();

	//Set the Loading State
	const [ loading , setLoading ] = useState(false);

	//Return
	return Modal.get( modal => (
		<section className="confirm">
			<header>
				<h2>
					{ modal.confirm.title }
				</h2>
			</header>
			<p>{ modal.confirm.content }</p>
			<div className="buttons">

				{/* Close Button */}
				<Button disabled={ loading } onClick={ () => !loading ? Modal.close() : null } inverted>{
					t('Components.Modal.cancel')
				}</Button>
				{/* On Continue */}
				<Button disabled={ loading } onClick={()=>{
					setLoading(true);
					modal.callback( setLoading );
				}}>
					<Preloader status={ loading } mini />
					{ t('Components.Modal.continue') }
				</Button>

			</div>
		</section>
	));

}